/** Classe global estável do root: o tema reconhece o `.p-dialog-header` que a contém (`:has(.hub-dialog-header)`). */
export const DIALOG_HEADER_ROOT_CLASS = "hub-dialog-header";
